<template>
  <div class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="labelCep"
      :readonly="readonly"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required, length: 9 , included:cep }"
      v-mask="'#####-###'"
      masked="true"
      @blur="consultaCep($event)"
    />
  </div>    
</template>

<script>
import CepService from "../../../../domain/cep/CepService";
import Endereco from "../../../../domain/cep/Endereco";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-protocolo-cep-empresa",
  template: ``,
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    protocolo: Object,
    required: Boolean
  },
  data() {
    return {
      campoEnum: CampoEnum,
      cep:""
    };
  },
  computed: {
    labelCep() {
      return `${
        this.label
      } <a class="btn-cep" href="http://www.correios.com.br/" title="Consultar meu CEP" target="_blank">
      <i class="fa fa-question-circle"></i>
    </a>`;
    }
  },
  methods: {
    validateCep: function(value) {
      let cleanValue = value.replace(/[^\d]/g, "");
      return cleanValue.length === 8;
    },
    consultaCep: function(cep) {
      if (this.validateCep(cep)) {
        this.cepService = new CepService(this.$http);
        this.cepService.getEndereco(cep).then(endereco => {
          this.cep = this.normalize(endereco.cep)
          if (endereco.logradouro && endereco.bairro) {
            this.protocolo[this.campoEnum.ENDERECO_EMPRESA] =
              endereco.logradouro;
            this.protocolo[this.campoEnum.BAIRRO_EMPRESA] = endereco.bairro;
            this.protocolo[this.campoEnum.CIDADE_EMPRESA] = endereco.localidade;
            this.protocolo[this.campoEnum.ESTADO_EMPRESA] = endereco.uf;
          }
        });
      } else {
        this.$store.dispatch("setEndereco", new Endereco());
      }
    },
    normalize(cep) {
      if (cep) {
        let cepClear = cep.replace(/[^\d]/g, "");

        if (this.validateCep(cep)) {
          cep = cepClear.replace(/(\d{5})(\d{3})/, "$1-$2");
        }
      }

      return cep;
    }
  },
  watch: {
    value(value) {
      this.$emit("input", this.normalize(value));
      if(value && value.length === 9){
        this.consultaCep(value)
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/CepEmpresa.vue